import PageTitle from '../../components/pagetitle/PageTitle'

import Accordion from '../../components/FaqSection/Accordion';
import ServiceSidebar from './sidebar'

import simag from '../../images/service/f.jpg'
import Gimg1 from '../../images/cta-bg.jpg'
import Gimg2 from '../../images/cta-2.jpg'
import Gimg3 from '../../images/cta-2.jpg'
import Gimg4 from '../../images/cta-4.jpg'


const ProjectLogistics = ({ serviceDetails }) => {
    return (
        <>
            <section className={`wpo-breadcumb-area ${serviceDetails.slug}`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={serviceDetails.title} />
            </section>
            <section id='details' className='wpo-service-single-page section-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12 order-lg-2">
                            <div className="service-single-wrap">
                                <h2 className='mt-0'>{serviceDetails.title}</h2>
                                <div className="title-image">
                                    <img src={simag} alt="" />
                                </div>

                                <p className='mb-3'>
                                    Experience is crucial for handling complex projects and oversized and heavy-lift cargoes. Managing transportation for large-scale projects requires experienced personnel committed to exploring all options, investigating every detail, and identifying potential obstacles. Our approach involves breaking down project logistics into essential elements and assigning direct supervision.
                                </p>
                                <p className='mb-3'>
                                    Advance trips by our Projects Operations Specialist to critical points in the project corridor ensure that OverflowLogistics has the firsthand knowledge needed to “make things happen.” A Project Coordinator is assigned to manage all aspects of communication, logistics, and transportation operations, serving as the direct liaison with the customer.
                                </p>
                                <p>
                                    Overflow Logistics’s Project Logistics success lies in our commitment to understanding project requirements. Our specialist advisors become fully conversant with the project’s needs, ensuring adherence to deadlines, HSE aspects, and special instructions. We specialize in project freight management and all associated planning and implementation services. Whether moving a single heavy lift or an entire industrial plant, we arrange customized transportation solutions for the whole of the route on a door-to-door basis.
                                </p>

                                <div className="row fc-gray my-4 pb-3">
                                    <h5>Key Project Logistics Services Include:</h5>
                                    <ul className="list-unstyled mt-3 fs-6">
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Customer-tailored Transportation Consultancy
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Project Logistics Feasibility Studies
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Road Studies
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Project Logistics Budget and Planning
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Project Flow Descriptions
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Cargo Supervision During Loading and Unloading, as well as in transit
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Full/partial charter by ocean and air
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Consolidation, packing, crating and containerization
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Purchase Order Management
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Cargo Tracking
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Transport Insurance
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Oversize Cargo Transportation
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Heavy Loads
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Barge Service
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Module Movement
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Pre-shipment Inspection
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Cargo Surveying
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Customs and Shipping
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Documentation
                                        </li>
                                    </ul>
                                </div>

                                <h3 className="quate">
                                    Successful project logistics requires precise planning and coordination, ensuring the safe transport of oversized and heavy cargo, adherence to timelines, and seamless execution from origin to destination.
                                </h3>

                                <div className="image-gallery">
                                    <h2>Eligibility checklist :</h2>
                                    <ul>
                                        <li><img src={Gimg1} alt="" /></li>
                                        <li><img src={Gimg2} alt="" /></li>
                                        <li><img src={Gimg3} alt="" /></li>
                                        <li><img src={Gimg4} alt="" /></li>
                                    </ul>
                                </div>
                                <Accordion />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 order-lg-1">
                            <ServiceSidebar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ProjectLogistics